import type { GlobalTopNavigation } from '../../../../amplienceTypes/schemas/imported/global-top-navigation-schema';
import type { HeaderOpenModalProps } from '../../core/layouts/MasterLayout';
import type { ReactElement } from 'react';
import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { useNavActionContext } from '../../../../utilities/context/dynamic/NavActionContext';
import { media } from '../../core/styles';
import { LocaleSelectorButton } from '../localeSelector/LocaleSelectorButton';
import { Logo } from '../logo/Logo';
import { SiteType } from '~/utilities/graphql/codegen';
import { useTopNavTracking } from '~/utilities/hooks/useTopNavTracking';

export type HeaderItemPosition = 'main-header' | 'side-header';

const SideNavHeaderStyles: Record<SiteType, RuleSet<object>> = {
  [SiteType.Aaf]: css`
    padding-right: ${({ theme }) => theme.size[2]};
    border-bottom: none;
  `,
  [SiteType.Employeeshop]: css``,
  [SiteType.Gstar]: css``,
  [SiteType.Outlet]: css``,
  [SiteType.Wahts]: css`
    padding-right: ${({ theme }) => theme.size[2]};
  `,
};

const S = {
  SidenavLogo: styled(Logo)`
    background-position: left center;
    margin-left: 16px;
    min-width: 140px;
    text-align: left;
    width: 50%;
  `,
  SideNavHeader: styled.div<{ $sideNavOpened: boolean }>`
    ${({ theme, $sideNavOpened }) => css`
      background: ${theme.colors.background.base};
      border: ${theme.borders.width.xs} solid ${theme.colors.border.subtle};
      border-top: none;
      border-left: none;
      box-sizing: border-box;
      display: flex;
      height: var(--top-nav-height);
      width: var(--side-nav-max-width);
      overflow: ${$sideNavOpened ? 'inherit' : 'hidden'};

      @media ${media(theme).greaterThan('sm')} {
        display: none;
      }

      ${SideNavHeaderStyles[theme.siteType]}
    `}
  `,
};

type SideNavHeaderProps = GlobalTopNavigation & HeaderOpenModalProps;

export const SideNavHeader = ({
  localeSelector,
  openedModal,
  setOpenedModal,
}: SideNavHeaderProps): ReactElement => {
  const { sideNavOpened } = useNavActionContext();
  const { track } = useTopNavTracking();

  return (
    <S.SideNavHeader suppressHydrationWarning $sideNavOpened={sideNavOpened}>
      <S.SidenavLogo logoPosition="side-header" />

      {localeSelector?.content && (
        <LocaleSelectorButton
          buttonPosition="side-header"
          {...localeSelector?.content}
          openedModal={openedModal}
          setOpenedModal={setOpenedModal}
          onClick={() =>
            track({
              event: 'nav_interaction',
              element: 'locale',
              interaction_type: 'open',
            })
          }
        />
      )}
    </S.SideNavHeader>
  );
};
